import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { Product } from '../../../core/models/product'
import { AddCartEvent, CartProduct } from '../../../cart/models/cart-models';

import { ThemeConfig } from '../../../core/helpers/theme-config'
import { FavoriteProduct, ToggleFavoriteEvent } from '../../../catalog/models/favorite-product';
import { Setting } from '../../../core/models/setting';
import { CombinedFacets } from '../../../facets/models/facet';

const isTileOrderable = ThemeConfig.get<boolean>('catalog', 'is-tile-orderable')

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListComponent {
  @Input() products: Product[]
  @Input() catalogItemPageSettings: Setting
  @Input() combinedFacets: CombinedFacets
  @Input() cartProducts: {[product: string]: CartProduct}
  @Input() favoritesProducts: FavoriteProduct[]
  @Input() quantityPicker: string
  @Input() allowOutOfStockOrdering: boolean

  @Output() onDetails = new EventEmitter<Product>()
  @Output() onAddCart = new EventEmitter<AddCartEvent>()
  @Output() onFavoriteToggle = new EventEmitter<ToggleFavoriteEvent>()

  get isTileOrderable(): boolean {
    return isTileOrderable
  }

  cartProduct(product: Product): CartProduct {
    return this.cartProducts[product._id]
  }

  openDetails(event: Product) {
    this.onDetails.emit(event)
  }

  isFavorite(product): boolean {
    if(product && this.favoritesProducts)
      return !!this.favoritesProducts.find(item => product.code === item.productCode)
    return false
  }

  toggleFavorite(e) {
    this.onFavoriteToggle.emit(e)
  }

  addCart(event: AddCartEvent) {
    this.onAddCart.emit(event)
  }
}
